import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import AddConsultant from "./AddConsultant";
import AddConsultantResume from "./AddConsultantResume";
import AddConsultantSubmit from "./AddConsultantSubmit";
import { useSelector } from "react-redux";
import SubmitPage from "./SubmitPage";

const CandidateDemo = () => {
  const [menuId, setMenuId] = useState(0);
  const [menuName, setMenuName] = useState("Persional Details");
  const personaldetails = useSelector(
    (state) => state.internalCandidateStatic.data
  );
  const previousExp = useSelector(
    (state) => state.internalCandidateStatic.peviousExperienceData
  );
  const officialReference = useSelector(
    (state) => state.internalCandidateStatic.officialReferenceData
  );

  const sideMenu = [
    { name: "Persional Details", id: 1 },
    { name: "Skill and Experience", id: 2 },
    { name: "Official Refference", id: 3 },
    { name: "Profile Review", id: 4 },
  ];
  const whichComponents = (name) => {
    if (name === "Persional Details") {
      return <AddConsultant setMenuName={setMenuName} setMenuId={setMenuId} />;
    } else if (name === "Skill and Experience") {
      return (
        <AddConsultantResume setMenuName={setMenuName} setMenuId={setMenuId} />
      );
    } else if (name === "Official Refference") {
      return (
        <AddConsultantSubmit setMenuName={setMenuName} setMenuId={setMenuId} />
      );
    } else if (name === "Profile Review") {
      return <SubmitPage setMenuName={setMenuName} setMenuId={setMenuId} />;
    }
  };

  const handleOnClickSideMenu = (menu, index) => {
    setMenuName(menu.name);
    setMenuId(index);
  };

  const isMenuEnabled = (id) => {
    if (id === 1) return true; // "Persional Details" is always enabled
    if (id === 2) return personaldetails !== null; // Enable if personalDetails is filled
    if (id === 3) return previousExp !== null && personaldetails !== null; // Enable if education is filled
    if (id === 4)
      return (
        officialReference !== null &&
        previousExp !== null &&
        personaldetails !== null
      ); // Enable if officialReference is filled
    return false;
  };

  return (
    <Box sx={{ padding: "20px", backgroundColor: "#fafafa" }}>
      <Grid container>
        <Grid item xs={12} sm={3} md={3} lg={3}>
          {sideMenu.map((menu, index) => {
            const isEnabled = isMenuEnabled(menu.id);
            return (
              <Typography
                key={index}
                sx={{
                  marginBottom: "10px",
                  cursor: "pointer",
                  borderRadius: "5px",
                  backgroundColor: "#fff",
                  border:
                    index === menuId ? "1px solid blue" : "1px solid gray",
                  padding: "9px",
                  pointerEvents: isEnabled ? "auto" : "none",
                  opacity: isEnabled ? 1 : 0.5,
                  "&:hover": {
                    border: "1px solid darkblue",
                  },
                }}
                onClick={
                  isEnabled
                    ? () => handleOnClickSideMenu(menu, index)
                    : undefined
                }
              >
                {menu.name}
              </Typography>
            );
          })}
        </Grid>
        <Grid
          item
          xs={12}
          sm={9}
          md={9}
          lg={9}
          sx={{ backgroundColor: "#f9f9f9" }}
        >
          {whichComponents(menuName)}
        </Grid>
      </Grid>
    </Box>
  );
};

export default CandidateDemo;
